export default {
    header: 'Join Events',
    activeNow: 'Ongoing',
    visibilityPrivate: 'Private',
    visibilityNetwork: 'Network',
    visibilityOpen: 'Open',
    interested: 'Register now',
    attend: 'Attend the event',
    enterEvent: 'Enter the virtual event',
    notinterested: 'I am not interested anymore',
    shownInterest: 'Registered',
    signUpToday: 'Sign up today!',
    aboutTheEvent: 'About the event',
    vfairsInfo:
        'Connect with companies and organisations from around the globe, in a sophisticated job fair simulation environment that enables real-time interaction between recruiters and candidates. Click on the virtual event you are interested in and sign up to receive notifications.',
    recruitingOrgs: 'Recruiting Companies & Organisations',
    preRegistered: 'Pre-registered',
    prepareForTheFair: 'Prepare for the virtual event',
    privateVFairHeader: 'Campus virtual event',
    privateVFairMessage:
        'This virtual event is hosted on a EFMD school platform and can therefore not be accessed from here.',
    missingEducationProfileMessage:
        'Please complete the education section of your profile to determine if your school has registered for the event.',
    missingEducationProfileButtonLabel: 'Go to profile',
    schoolNotJoinedNetworkEventMessage:
        'Your school has not yet signed up for this virtual event, reach out to your program director or careers department to ask for participation.',
    companyNotJoinedNetworkEventMessage:
        'Your organization has not an active Virtual Booth at this event. Reach out to Highered to ask for participation.',
    studentNotVerifiedSchoolMessage:
        'You have not verified to your school {schoolName}. Please verify to your school to access this event.',
    pavilions: 'Pavilions',
    general: 'General',
    allCompanies: 'All companies',
    lobby: 'Lobby',
    inviteCode: 'Invite code',
    eventRequiresInvitation: 'This event requires an invitation',
    haveCode: 'I have a code',
    checkCode: 'Check code',
    invalidCode: 'Invalid code',
    registeredSuccessfully: 'Registered successfully',
    searchingForChatUser: 'Looking for a chat partner...',
    filterByUniversity: 'Filter by university',
    showingAllUniversities: 'Showing all universities',
    noVFairsAvailable: 'No virtual events available',

    pavilionTabs: {
        lobby: 'Lobby',
        booths: 'Booths',
        jobs: 'jobs',
        webinars: 'Webinars',
        conference: 'Conference',
        chat: 'Chat',

        home: 'home',
        companies: 'companies',
        articles: 'articles',
        events: 'events',
        importantInfo: 'Important info',
        degreesPrograms: 'Degrees / Programs',
    },
    events: {
        webinars: 'Webinars',
        liveEvents: 'Live Events',
        videos: 'Videos',
        noEventsAvailable: 'No events available',
        noWebinarsAvailable: 'No webinars available',
        showCompleted: 'Show completed',
        hideCompleted: 'Hide completed',
        liveNow: 'Live now',
        joinTheEvent: 'Join the event',
        addToCalendar: 'Add to calendar',

        date: 'Date',
        time: 'Time',
        status: 'Status',
        completed: 'Completed',

        linkWillShow: 'Link will show when the event goes live',
    },
    links: {
        masterclasses: {
            header: 'Masterclasses',
            buttonCaption: 'Watch the Masterclasses',
            description:
                'View a wide array of top-quality masterclasses including “CV Optimization to Get Hired”, “Rock Your Linkedin Profile” and “Salary Negotiation”, amongst many others, for all stages of your career trajectory!',
        },
        detailsmasterclass: {
            header: 'Attend the masterclass',
        },
        cv: {
            header: 'CV Template',
            buttonCaption: 'Download CV Template',
            description:
                'Access the Highered ATS-friendly CV template in order to make an optimal professional impression with recruiters.',
        },
        elevatorPitch: {
            header: 'Elevator Pitch Challenge ',
            buttonCaption: 'Send your pitch',
            description:
                'Take the “Pitch Perfect Challenge”! This is your opportunity to pitch your value to hundreds of recruiters from top global companies and organisatons!',
        },
    },
    footerHeaders: {
        social: 'Follow us for more updates',
        sponsored: 'Sponsored by',
        organized: 'Organized by',
    },
    educationPopup: {
        step00: {
            header: 'Share your education',
            subtitle: 'To continue, let the employers know more about you',
            continueLabel: 'Add my education',
            leaveLabel: 'Dismiss',
        },
        step01: {
            header: 'Tell us your education',
        },
        step02: {
            loadingLabel: 'Just a moment...',
        },
        step03: {
            header: 'Education completed',
            subtitle: 'You can now share your profile and be more interesting among the employers',
            continueLabel: 'Continue exploring the virtual event',
        },
        error: {
            header: 'Wops! An error occurred!',
            subtitle:
                'We were not able to store your educational information. Please try again later.',
        },
    },
    companies: {
        visitWebsite: 'Visit Website',
        sendMail: 'Send Email',
        profile: 'Company profile',
        links: 'Links',
        faq: 'FAQ',
    },
    conference: {
        dayN: 'Day {n}',

        clickHere: 'Click here',
        unableToWatch: 'Unable to watch?',
    },
    profile: {
        headerRegister: 'Required Profile Fields',
        headerEnter: 'Complete your profile to enter the event',
        description:
            'Complete the required profile fields to proceed with registering for the event. By completing your profile it will help us to connect you with relevant job opportunities and events that best match your profile.',

        termsAndConditions:
            'By checking this box, you are agreeing to our <a href="https://highered.global/terms-and-conditions/" target="_blank">terms and conditions</a>.',

        confirmRegister: 'Confirm registration',
        confirmEnter: 'Enter the event',

        proceedRegister: 'Proceed',
        proceedRegisterText:
            "Complete your registration by following an external link. Click 'Proceed' to continue.",

        validation: {
            firstName: 'First name',
            lastName: 'Last name',
            nationality: 'Nationality',
            location: 'Location',
            disability: 'Disability',
            ethnicMinority: 'Ethnic Minority',
            pronoun: 'Pronoun',
            gender: 'Gender',
            country: 'Current location',
            email: 'Valid contact email',
            languages: 'At least one language',
            skills: 'At least one skill',
            workAuthorization: 'At least one work authorization',
            terms: 'Agree to terms and conditions',
            candidateStudyPrograms: 'At least one complete education entry',
            preferences: 'At least one function',

            header: 'Please fill in all the required fields',
            termsPolite: 'Please agree to the terms and conditions',
        },
        completed: {
            thankYou: 'Thank you for signing up!',
            instagram: 'Follow us on Instagram',
            interview: 'Improve interview skills',
            cv: 'Upload a new CV',
        },
    },
};
